import Navbar from "../components/navbar";
import { useRef, useState, useEffect } from "react";
import Aos from "aos";
import { Icon } from "@iconify/react";
import introCartoon from "../media/readKid.avif";
import "aos/dist/aos.css";
import { motion } from "motion/react";
import sadRobot from "../media/sadRobot.jpg"
import { db } from "../firebase/firebaseConfig";
import dummyAva from "../media/robotKids.avif"
import spongebob from "../media/spongebob.avif"
import { useNavigate } from "react-router-dom";
import sonic from "../media/sonic.avif"
import Swal from "sweetalert2";
import moana from "../media/moana.avif"
import unicorn from "../media/unicorn.avif"
import dragon from "../media/dragon.avif"
import noavatar from "../media/noiMG.png"
import mario from "../media/mario.avif"
import cat from "../media/cat.avif"
import frozen from "../media/frozen.avif"
import Loader from "./loader";
import Cart from "../components/cart";
import useFirebaseStore from "../store/firebasestore";
import { Helmet } from "react-helmet";
import "../css/branding.css"
import FonSideBar from "../components/fonnSideBar";

import { doc, setDoc, updateDoc } from "firebase/firestore";
import useGenStore from "../store/genstore";
function Branding() {
    const [stickerIndex, setSi] = useState(8)
         const setFonView = useGenStore((s)=>s.setFonView)
    
    const cartView = useGenStore((s)=>s.cartView)
     const [count, setCount] = useState(0);
     const [batchSize, setBatchSize] = useState(0)
     const navigate = useNavigate()
     const [activeCard, setActiveCard]= useState(0)
     const [studentName, setStudentname] = useState("")
     const [labelType, setLabelType] = useState("")
     const authStatus = useFirebaseStore((s)=>s.authStatus)
     const userID = useFirebaseStore((s)=>s.userID)
     const cartItems = useFirebaseStore((s)=>s.cartItems)



    useEffect(()=>{

  if(labelType === "Iron-on Label"){
    setBatchSize(30)
    setCount(30)
  }

  if(labelType === "Stick-on Label"){
    setBatchSize(30)
    setCount(30)
  }

  if(labelType === "Iron-on (30) & Stick-on (30) Combo"){
    setBatchSize(60)
    setCount(60)
  }

  if(labelType === ""){
    setBatchSize(0)
    setCount(0)
  }

},[labelType])


const toNextCard=()=>{
  if (!studentName.trim() || !labelType.trim()) {
  Swal.fire({
    text: "Please fill in all the fields.",
    imageUrl: sadRobot,
    imageWidth: 150,
    imageHeight: 150,
    imageAlt: "Error icon",
  });
  return;
}
setActiveCard(1)
}
const increase = () => {
  // if(labelType === "Iron-on & Stick-on Combo") return
  setCount(prev => prev + batchSize);
};

const decrease = () => {
  // if(labelType === "Iron-on & Stick-on Combo") return
  setCount(prev => Math.max(batchSize, prev - batchSize));
};

 
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const stickerArray=[
    {avatarImg:spongebob, avatarName: "Sponge Bob", index:0},
    {avatarImg:sonic, avatarName: "Sonic", index:1},
    {avatarImg:moana, avatarName: "Mirabel", index:2},
    {avatarImg:dragon, avatarName: "Dinosaur", index:3},
    {avatarImg:mario, avatarName: "Super Mario", index:4},
    {avatarImg:cat, avatarName: "Bluey", index:5},
    {avatarImg:frozen, avatarName: "Elsa", index:6},
    {avatarImg:unicorn, avatarName: "Unicorn", index:7},
    {avatarImg:noavatar, avatarName: "No Avatar", index:8},
  ]
  const chooseAv=(index)=>{
      setSi(index)
  }
  

  useEffect(() => {
  if (authStatus !== "authenticated") {
    const guestCart = JSON.parse(localStorage.getItem("guestCartItems") || "[]");
    useFirebaseStore.setState({ cartItems: guestCart });
  }
}, [authStatus]);

const addtoCart = async () => {

  const sltSticker =
    stickerIndex !== undefined && stickerArray[stickerIndex]
      ? stickerArray[stickerIndex].avatarName
      : undefined;

  // Validate fields
  if (!studentName || !labelType) {
    Swal.fire({
      text: "Please fill in all the fields.",
      imageUrl: sadRobot,
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: "Error icon",
    });
    return;
  }

  if (!sltSticker) {
    Swal.fire({
      text: "Please select an avatar.",
      imageUrl: sadRobot,
      imageWidth: 150,
      imageHeight: 150,
      imageAlt: "Error icon",
    });
    return;
  }

  const id = crypto.randomUUID();
  let costPerBatch = 0;
  let batchSize = 0;
  if (labelType == "Iron-on Label") {
    costPerBatch = 1100;
    batchSize = 30;
  } else if (labelType == "Stick-on Label") {
    costPerBatch = 1300;
    batchSize = 30;
  } else if (labelType == "Iron-on (30) & Stick-on (30) Combo") {
    costPerBatch = 2000;
    batchSize = 60;
  }

  const sltcartItems = {
    id,
    batchSize,
    studentName,
    labelType,
    count,
    sltSticker,
    stickerIndex,
    costPerBatch,
  };

  // ✅ GUEST CHECKOUT (not signed in) — use localStorage
  if (authStatus !== "authenticated" || !userID) {
    const guestCart = JSON.parse(localStorage.getItem("guestCartItems") || "[]");
    const newGuestCart = [...guestCart, sltcartItems];
    localStorage.setItem("guestCartItems", JSON.stringify(newGuestCart));
    useFirebaseStore.setState({ cartItems: newGuestCart });

    Swal.fire("", "Item added to cart!", "success").then(() => {
      setActiveCard(0);
    });
    return;
  }

  // ✅ SIGNED-IN — use Firestore (existing logic)
  const newCartItems = [...cartItems, sltcartItems];

  const userRef = doc(db, "Users", userID);
  await updateDoc(userRef, {
    cartItems: newCartItems,
  }).then(() => {
    Swal.fire("", "Item added to cart!", "success").then(() => {
      setActiveCard(0);
    });
  });
};

  return (
    <>
    <Helmet>
  <title>Create Your Custom School Labels | Personalized Name Labels for Uniforms & Stationery</title>
  <meta name="description" content="Design your own customized school labels. Choose iron-on labels for uniforms or stick-on labels for stationery. Add student name, select avatar, and pick quantity. Start creating now!" />
</Helmet>
    <FonSideBar/>
      <div className={`floatCart ${cartView ? "floatCartActive" : ""}`}>
        <Cart />
      </div>
    {authStatus == "loading" ? (<Loader/>):(  <div className="Branding">
      <Navbar />
      <div className="brandingPlacer">
        <div className="brandingCard brandingCard1">
          <div className="bcCont">
            <div className="brandingCardIntro">
              <img src={introCartoon} alt="" />
              <div className="brandingCardIntroCont">
                <h3>Create Your Label</h3>
                <p>You are almost there.</p>
              </div>
            </div>
            <div className="labelMainContGen">
              {activeCard == 0 ? ( 
                <div className="labelInputs">
                <div className="labelInput">
                  <p>Students Name:</p>
                  <div className="labelInpuWrap">
                    <input type="text"
                     placeholder="Enter Name" 
                     value={studentName}
                     onChange={(e)=>setStudentname(e.target.value)}
                      />
                  </div>
                </div>
                <div className="labelInput">
                  <p>Label Type:</p>
                  <div className="labelInpuWrap">
                  <select
                    value={labelType}
                    onChange={(e)=>setLabelType(e.target.value)}
                  >
                    <option value="">Select Label</option>
                    <option value="Iron-on Label">Iron-on Label</option>
                    <option value="Stick-on Label">Stick-on Label</option>
                    <option value="Iron-on (30) & Stick-on (30) Combo">Iron-on (30) & Stick-on (30) Combo</option>
                  </select>
                  </div>
                </div>
                <div className="labelBtnWrap">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={()=>{
                       setFonView(false)

                      navigate("/")
                    }}
                    className="secBtn"
                  >
                    Cancel
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={toNextCard}

                    className="priBtn"
                  >
                    Next
                  </motion.button>
                </div>
              </div>):(
<div className="selectAvator">
                <div className="selectActAvatar">
                    <div className="selectedAvatar">
                            {stickerIndex == 8 ? ( <div className="circle-containerA boyContainer">
  <div className="circle-maskA">
    <img src={dummyAva} alt="person" className="person-imgA" />
  </div>
  <img src={dummyAva} alt="person" className="person-topA" />
</div>):( <div className="circle-containerA ">
  <div className="circle-maskA ">
    <img src={stickerArray[stickerIndex].avatarImg} alt="person" className="person-imgA" />
  </div>
  <img src={stickerArray[stickerIndex].avatarImg} alt="person" className="person-topA" />
</div>)}

            
                    </div>
                  <p>Select Avatar</p>

                  <div className="AvatarsWrap">
                    {stickerArray.map((sticker, index)=>(
<motion.div 
                    key={index}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={() => chooseAv(index)}
                    className="avatarCard">
                      <div className="avImg">
                            <img src={sticker.avatarImg} alt="" />
                      </div>
                      <span>{sticker.avatarName}</span>
                    </motion.div>
                    )

                    )}
                    
                 
                  </div>
                </div>
                <div className="labelQuantity">
                  <p>How many pieces? {labelType === "Iron-on (30) & Stick-on (30) Combo" && <span>Iron-on (30) & Stick-on (30)</span> }</p>
               <div className="lQInputWrap">
      <div className="lqLeftIcon" onClick={decrease}>
        <Icon
          className="faIcon"
          icon="solar:minus-circle-line-duotone"
        />
      </div>

      <div className="lqMidNumber">
        <p >{count}</p>
      </div>

      <div className="lqRightIcon" onClick={increase}>
        <Icon
          className="faIcon"
          icon="solar:add-circle-line-duotone"
        />
      </div>
    </div>
                </div>
                    <div className="labelBtnWrap">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={()=>setActiveCard(0)}
                    className="secBtn"

                  >
                    Back
                  </motion.button>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.8 }}
                    onClick={addtoCart}
                    className="priBtn"
                  >
                    Add to Cart
                  </motion.button>
                </div>
              </div>
              )}
                          
            </div>
          </div>
        </div>
      </div>
    </div>)}
    </>
 
  );
}

export default Branding;
